export const cast = <T>(x: T) => x;
